interface Props {
  toggled: boolean;
  onChange: (toggled: boolean) => void;
  labels?: string[];
  disabled?: boolean;
  mobile?: boolean;
}

const BaseToggleSwitch: React.FC<Props> = ({
  toggled,
  onChange,
  labels = [],
  disabled = false,
  mobile = false,
}) => {
  const handleKeyPress = (e: any) => {
    if (e.keyCode !== 32) return;
    e.preventDefault();
    onChange(!toggled);
  };
  return (
    <div>
      <div
        onClick={disabled ? undefined : () => onChange(!toggled)}
        className={`${mobile ? "toggle-switch-mobile" : "toggle-switch"}`}
      >
        <input
          type="checkbox"
          className="toggle-switch-checkbox"
          checked={toggled}
          onChange={() => {}}
          disabled={disabled}
        />
        <label
          className="toggle-switch-label"
          tabIndex={disabled ? -1 : 0}
          onKeyDown={disabled ? undefined : (e) => handleKeyPress(e)}
        >
          <span
            className={
              disabled
                ? "toggle-switch-inner toggle-switch-disabled"
                : labels.length > 0
                ? "toggle-switch-inner"
                : "toggle-switch-inner-nodata"
            }
            data-untoggled={labels[0]}
            data-toggled={labels[1]}
            tabIndex={-1}
          />
          <span
            className={`${
              disabled
                ? "toggle-switch-switch toggle-switch-disabled"
                : "toggle-switch-switch"
            }`}
            tabIndex={-1}
          />
        </label>
      </div>
    </div>
  );
};
export default BaseToggleSwitch;
